<template>
    <v-container style="max-width: 1000px;">
      <v-row justify="center">
        <v-col cols="12" class="d-flex justify-center">
          <div class="responsive-container">
            <img src="@/assets/logo-logo.png" alt="Logo" class="responsive-logo">
            <img src="@/assets/logo1.svg" alt="Logo Text" class="responsive-text pl-2">
        </div>
        </v-col>
      </v-row>      
      <v-row justify="center">
        <v-col cols="12" class="d-flex justify-center">
          <v-autocomplete                
                class="mt-0"
                prepend-inner-icon="mdi-magnify"
                density="comfortable"
                ref="autocomplete" 
                v-model="searchQuery"
                :items="filteredTerms"
                variant="outlined"
                style="max-width: 645px; min-width: 330px;"
                item-title="term"
                item-value="name"
                @update:modelValue="navigateToTerm"
                clear-icon="mdi-close-circle" 
                clearable 
                hide-details
                placeholder="Search..."
                menu-icon=""
                bg-color="white"
                color="blue"
                base-color="primary"
            ></v-autocomplete>   
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" class="d-flex flex-column align-items-center justify-center text-center">
          <span class="text-body-1 font-weight-medium link-style" @click="$router.push('/a-z')">{{ termCount }} Total Entries</span>
          <h2>Top 10 Searches</h2>
        </v-col>
      </v-row>

      <v-row class="pl-4">
        <v-col
          v-for="term in rankedTerms.slice(0, 10)"
          :key="term.id"
          cols="12"
          md="4"
          sm="6"
          class="pa-2"
        >
          <div class="term-item">
            <div class="term-name" @click="navigateToTerm(term.name)">{{ term.term }}</div>
            <div class="term-definition" v-html="wrapDefinition(term.definition)"></div>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mt-5 mb-5"></v-divider>
      

      <v-row justify="center">
        <v-col class="d-flex justify-center" cols="12" md="4" sm="6">
        <div class="transparent-div d-flex" @click="openLink('https://www.youtube.com/@puregroundcontrol')">
          <span class="pl-4 pt-2">
            <svg class="scalable-svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 461.001 461.001" xml:space="preserve"><g><path style="fill:#F61C0D;" d="M365.257,67.393H95.744C42.866,67.393,0,110.259,0,163.137v134.728c0,52.878,42.866,95.744,95.744,95.744h269.513c52.878,0,95.744-42.866,95.744-95.744V163.137C461.001,110.259,418.135,67.393,365.257,67.393z M300.506,237.056l-126.06,60.123c-3.359,1.602-7.239-0.847-7.239-4.568V168.607c0-3.774,3.982-6.22,7.348-4.514l126.06,63.881C304.363,229.873,304.298,235.248,300.506,237.056z"/></g></svg>
          </span>
          <span class="term-definition pt-4 pl-3 pr-5">YouTube Channel</span>
        </div>
      </v-col>
      <v-col class="d-flex justify-center" cols="12" md="4" sm="6">
        <div class="transparent-div d-flex" @click="openLink('https://www.reddit.com/r/bjj/')">
          <span class="pl-4 pt-2">
            <svg class="scalable-svg" viewBox="0 0 429.709 429.709" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M429.709,196.618c0-29.803-24.16-53.962-53.963-53.962c-14.926,0-28.41,6.085-38.176,15.881c-30.177-19.463-68.73-31.866-111.072-33.801c0.026-17.978,8.078-34.737,22.104-45.989c14.051-11.271,32.198-15.492,49.775-11.588l2.414,0.536c-0.024,0.605-0.091,1.198-0.091,1.809c0,24.878,20.168,45.046,45.046,45.046s45.046-20.168,45.046-45.046c0-24.879-20.168-45.046-45.046-45.046c-15.997,0-30.01,8.362-38.002,20.929l-4.317-0.959c-24.51-5.446-49.807,0.442-69.395,16.156c-19.564,15.695-30.792,39.074-30.818,64.152c-42.332,1.934-80.878,14.331-111.052,33.785c-9.767-9.798-23.271-15.866-38.2-15.866C24.16,142.656,0,166.815,0,196.618c0,20.765,11.75,38.755,28.946,47.776c-1.306,6.68-1.993,13.51-1.993,20.462c0,77.538,84.126,140.395,187.901,140.395s187.901-62.857,187.901-140.395c0-6.948-0.687-13.775-1.991-20.452C417.961,235.381,429.709,217.385,429.709,196.618z M345.746,47.743c12,0,21.762,9.762,21.762,21.762c0,11.999-9.762,21.761-21.762,21.761s-21.762-9.762-21.762-21.761C323.984,57.505,333.747,47.743,345.746,47.743z M23.284,196.618c0-16.916,13.762-30.678,30.678-30.678c7.245,0,13.895,2.538,19.142,6.758c-16.412,14.08-29.118,30.631-37.007,48.804C28.349,215.937,23.284,206.868,23.284,196.618z M333.784,345.477c-31.492,23.53-73.729,36.489-118.929,36.489s-87.437-12.959-118.929-36.489c-29.462-22.013-45.688-50.645-45.688-80.621c0-29.977,16.226-58.609,45.688-80.622c31.492-23.53,73.729-36.489,118.929-36.489s87.437,12.959,118.929,36.489c29.462,22.013,45.688,50.645,45.688,80.622C379.471,294.832,363.246,323.464,333.784,345.477z M393.605,221.488c-7.891-18.17-20.596-34.716-37.005-48.794c5.247-4.22,11.901-6.754,19.147-6.754c16.916,0,30.678,13.762,30.678,30.678C406.424,206.867,401.353,215.925,393.605,221.488z" style="fill:#181A1C;"/><circle style="fill:#D80000;" cx="146.224" cy="232.074" r="24.57"/><circle style="fill:#D80000;" cx="283.484" cy="232.074" r="24.57"/><path d="M273.079,291.773c-17.32,15.78-39.773,24.47-63.224,24.47c-26.332,0-50.729-10.612-68.696-29.881c-4.384-4.704-11.751-4.96-16.454-0.575c-4.703,4.384-4.96,11.752-0.575,16.454c22.095,23.695,53.341,37.285,85.726,37.285c29.266,0,57.288-10.847,78.905-30.543c4.752-4.33,5.096-11.694,0.765-16.446C285.197,287.788,277.838,287.44,273.079,291.773z" style="fill:#181A1C;"/></g></svg>
          </span>
          <span class="term-definition pt-4 pl-3 pr-5">Reddit Community</span>
        </div>
      </v-col>    
      </v-row>      

    

    </v-container>


    <v-bottom-navigation bg-color="#eaecf0">
      <v-btn value="a2z" :to="{ path: '/a-z' }">
          <v-icon>mdi-order-alphabetical-ascending</v-icon>
          <span>List</span>
        </v-btn>

        <v-btn @click="redirectToRandomTerm">
          <v-icon>mdi-arrow-decision</v-icon>
          <span>Random</span>
        </v-btn>

        <v-btn value="FAQ" :to="{ path: '/faq' }">
          <v-icon>mdi-frequently-asked-questions</v-icon>
          <span>FAQ</span>
        </v-btn>

        <v-btn value="donate" href="https://www.paypal.com/donate/?hosted_button_id=3QBMVFF8CQAUS" target="_blank">
          <v-icon>mdi-hand-heart-outline</v-icon>
          <span>Donate</span>

        </v-btn>
      </v-bottom-navigation>


</template>

<script>
import { useMainStore } from '@/stores/mainStore';
import { mapState } from 'pinia';

export default {
  data() {
    return {
      searchQuery: '',
    };
  },
  async created() {
    //const mainStore = useMainStore();
    //await mainStore.fetchTerms();

    const urlParams = new URLSearchParams(window.location.search);
    const termId = urlParams.get('t');
    if (termId) {
      this.navigateToTerm(termId);
    }
  },
  computed: {
    ...mapState(useMainStore, ['terms']),
    filteredTerms() {

      const query = (this.searchQuery ?? '').toLowerCase(); // Provide a default empty string
      return Object.entries(this.terms)
        .map(([key, term]) => ({ ...term, name: key }))
        .filter(term =>
          term.term.toLowerCase().includes(query) && term.enabled !== false
        )
        .sort((a, b) => a.term.localeCompare(b.term)); // Sort alphabetically
    },
    termCount() {
      return Object.keys(this.terms).length;
    },
    rankedTerms() {
      return Object.entries(this.terms)
        .map(([key, term]) => ({ ...term, name: key }))
        .filter(term =>
          term.term.toLowerCase() && term.enabled !== false && 'popularity' in term
        )
        .sort((a, b) => b.popularity - a.popularity);
    },        

  },
  methods: {
  navigateToTerm(term) {
    if (!term) {
      return; // Exit if termName is undefined or null
    }
    this.$router.push(`/term/${term}`);
  },
  wrapDefinition(definition) {
  // Strip HTML tags
  definition = definition.replace(/<[^>]+>/g, '');

  // Truncate if length is greater than 20 characters
  definition = definition.length > 20 ? this.truncateText(definition, 100) : definition;

  // Wrap in a div with id term definition
  return `<div id="term-definition">${definition}</div>`;
    },
  truncateText(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    const truncated = text.slice(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(' ');
    return lastSpaceIndex === -1 ? truncated + '...' : truncated.slice(0, lastSpaceIndex) + '...';
  },
  openLink(url) {
    if (typeof window !== 'undefined') {
      window.open(url, '_blank');
    } else {
      console.error('window is not defined');
    }
  },
  redirectToRandomTerm() {
      const store = useMainStore();
      store.redirectToRandomTerm(this.$router);
    },
  },

};
</script>

<style scoped>

.scalable-svg {
  width: 100%;
  max-width: 40px;
  height: auto;
}

.transparent-div {
  background-color: transparent;
  transition: background-color 0.3s ease;
  cursor: pointer;
  width: 100%;
  max-width: "150px";
}

.transparent-div:hover {
  background-color: rgba(0, 0, 0, 0.1); /* Change to your desired hover color */
}

.responsive-container {
  display: flex;
  flex-direction: row; /* Display images side by side */
  align-items: center;
  justify-content: center; /* Center the images horizontally */
  width: 80%;
  max-width: 600px;
  height: auto;
}

.responsive-logo {
  max-width: 20%; /* Adjust as needed to fit your layout */
  height: auto;
}

.responsive-text {
  max-width: 70%; /* Adjust as needed to fit your layout */
  height: auto;  
}

.term-item {
  /* max-width: 300px; Adjust the width as needed */

}


.term-name {
  font-family: 'Linux Libertine', 'Georgia', 'Times', 'Source Serif Pro', serif;
  font-size: 1.2em;
  font-weight: 400;
  color: #1E90FF;
  cursor: pointer; /* Indicate clickable item */
}

.term-name:hover {
  color: blue; /* Change color on hover */
}

.term-definition {
  font-family: sans-serif;
    font-size: 0.9em;
}

.link-style {
  color: inherit; /* Inherit color from parent */
  text-decoration: none; /* Remove underline */
  cursor: pointer; /* Change cursor to pointer */
  color: #1E90FF;
  cursor: pointer; /* Indicate clickable item */  
}

.link-style:hover {
  color: blue; /* Change color on hover */
}
</style>
